import each from 'lodash/each'
import includes from 'lodash/includes'
import config from '@/config'
import axios from 'axios'
import router from '@/router'

const state = {
  added: [],
  items: [],
  skuArray: [],
  variantsArray: [],
  checkoutStatus: null,
  cartName: 'Skyhighpartyrentals',
  currency: config.currency,
  totalAmount: 0,
  discount: 0,
  shipping: {}
}

// getters
const getters = {
  checkoutStatus: state => state.checkoutStatus,
  items: state => state.items,
  // toNumber: (state, value, x) => {
  //     console.log('vvvvvvvvvvvvvvvvv', state, value, x);
  //     value *= 1;
  //     return isNaN(value) ? 0 : value;
  // },
  loadItems: () => {
    let items = localStorage !== null ? localStorage[state.cartName + '_items'] : null
    if (items !== null && JSON !== null) {
      try {
        items = JSON.parse(items)
        for (let i = 0; i < items.length; i++) {
          let item = items[i]
          if (item._id !== null && item.name !== null && item.price !== null) {
            state.items.push(item)
            state.skuArray.push(item._id)
            state.variantsArray.push(item.vid)
          }
        }
      } catch (err) {
      }
    }
  },

  // get the total price for all items currently in the cart
  getTotalWeight: state => () => {
    let totalWeight = 0
    for (let i = 0; i < state.items.length; i++) {
      let item = state.items[i]
      let quantity = item.quantity * item.weight
      quantity *= 1
      quantity = isNaN(quantity) ? 0 : quantity
      totalWeight += quantity
    }
    return totalWeight
  },

  // get the total price for all items currently in the cart
  totalCount: () => {
    let count = 0
    for (let i in state.items) {
      let item = state.items[i]
      // if (_id === undefined || item._id === _id) {
      let quantity = item.quantity
      quantity *= 1
      quantity = isNaN(quantity) ? 0 : quantity
      count += quantity
      // }
    }
    return count
  },
  // getImage: state => (img) => {
  //     if (img) {
  //         try {
  //             return require('@/assets/' + img)
  //         }
  //         catch (e) {
  //             return require('@/assets/486x325.png')
  //         }
  //     }
  // },
  getDiscount: state => () => {
    return state.discount
  },
  // get the total price for all items currently in the cart
  getTotalAmount: state => () => {
    let total = 0
    for (let i = 0; i < state.items.length; i++) {
      let item = state.items[i]
      let quantity = item.quantity * item.price
      quantity *= 1
      quantity = isNaN(quantity) ? 0 : quantity
      total += quantity
    }
    state.totalAmount = total

    return total
  },

  getQuantity: state => ({ _id, vid }) => { // Get quantity based on the combination of product_id and variant_id
    for (let i in state.items) {
      if (state.items[i]._id === _id && state.items[i].vid === vid) {
        return state.items[i].quantity
      }
    }
  },
  checkCart: state => ({ id, vid }) => { // Returns true when there is item in cart
    return includes(state.skuArray, id) && includes(state.variantsArray, vid)
  }
}

// actions
const actions = {
  async getBestShipper ({ commit, state, getters }, payload) {
    getters.loadItems
    let weight = getters.getTotalWeight().toString()
    let cartValue = getters.getTotalAmount().toString()
    try {
      let res = await axios.get('/api/shippings/best?weight=' + weight + '&cartValue=' + cartValue)
      commit('getBestShipper', res.data[0])
    } catch (err) { }
  },
  async addToCart ({ commit, dispatch, getters }, payload) {
    commit('addToCart', payload)
    let weight = getters.getTotalWeight().toString()
    let cartValue = getters.getTotalAmount().toString()
    try {
      let res = await axios.get('/api/shippings/best?weight=' + weight + '&cartValue=' + cartValue)
      commit('getBestShipper', res.data[0])
    } catch (err) { }
  },
  checkout ({ commit }, payload) {
    commit('checkout', payload)
  },
  applyDiscount ({ commit }, payload) {
    commit('applyDiscount', payload)
  },
  async checkout ({ commit, state, rootState }, { method, params, merchantID, receipient_name, shipping, address }) {
    params.exchange_rate = currency.exchange_rate
    if (!params.exchange_rate || isNaN(params.exchange_rate) || params.exchange_rate === '') params.exchange_rate = 1
    if (!params.couponAmount || isNaN(params.couponAmount) || params.couponAmount === '') params.couponAmount = 0
    params.currency_code = currency.code
    params.paypal_currency = currency.paypal
    params.discount = params.couponAmount
    params.email = rootState.auth.user.email
    params.uid = rootState.auth.user._id
    params.address = address
    if (receipient_name || receipient_name === '') {
      receipient_name = rootState.auth.name
    }
    switch (method) {
      case 'PayPal':
        let data = {
          cmd: '_cart',
          business: merchantID,
          upload: '1',
          rm: '2',
          charset: 'utf-8',
          data: state.items,
          options: params
        }
        let form = document.createElement('form')
        form.setAttribute('id', 'paypalForm')
        form.setAttribute('action', '/api/pay/paypal')
        form.setAttribute('method', 'GET')
        form.setAttribute('style', 'display:none;')

        if (data !== null) {
          each(data, function (value, name) {
            if (value !== null) {
              let input = document.createElement('input')
              input.setAttribute('type', 'hidden')
              input.setAttribute('name', name)
              input.value = JSON.stringify(value)
              form.append(input)
            }
          })
        }

        document.querySelector('body').append(form)
        form.submit()
        if (config.clearCart) commit('clearCart')
        form.remove()
        break
      case 'COD':
        let cartItems = state.items
        let total = Math.round((state.totalAmount - params.couponAmount) * params.exchange_rate * 100) / 100
        let subtotal = Math.round((state.totalAmount - params.couponAmount) * params.exchange_rate * 100) / 100
        let items = []
        for (let ix in cartItems) {
          let i = cartItems[ix]
          items.push({ vendor_id: i.vendor_id, vendor_name: i.vendor_name, vendor_email: i.vendor_email, sku: i.sku, name: i.name, url: i.image, description: i.slug, price: Math.round(i.price * params.exchange_rate * 100) / 100, quantity: i.quantity, currency: params.currency_code })
        }
        if (params.discount > 0) { items.push({ name: 'Coupon Discount', url: '-', description: '-', price: -Math.round(params.discount * params.exchange_rate * 100) / 100, quantity: 1, currency: params.currency_code }) }
        let orderDetails = {
          uid: params.uid,
          email: params.email,
          phone: params.phone,
          address: params.address,
          payment: { state: 'Pending', method: 'COD' },
          amount: { total: total, currency: params.currency_code, exchange_rate: params.exchange_rate, details: { shipping: Math.round(params.shipping * 100) / 100, subtotal: subtotal } },
          items: items,
          status: 'Payment Pending'
        }
        try {
          await axios.post('/api/orders', orderDetails, true, true)
          if (config.clearCart) commit('clearCart')
          router.push('/admin/orders')
        } catch (err) { commit('setError', err, { root: true }) }
        break

      case 'Stripe':
        let stripeData = {
          items: state.items,
          options: params
        }
        let form2 = document.createElement('form')
        form2.setAttribute('id', 'stripeForm')
        form2.setAttribute('action', '/api/pay/stripe')
        form2.setAttribute('method', 'GET')
        form2.setAttribute('style', 'display:none;')

        if (stripeData !== null) {
          each(stripeData, function (value, name) {
            if (value !== null) {
              let input = document.createElement('input')
              input.setAttribute('type', 'hidden')
              input.setAttribute('name', name)
              input.value = JSON.stringify(value)
              form2.append(input)
            }
          })
        }
        document.querySelector('body').append(form2)
        form2.submit()
        // if (clearCart) commit('clearCart')
        form2.remove()
        break
      default:
        console.log('Unknown checkout service: ' + method)
        break
    }
  }
}

// mutations
const mutations = {
  getBestShipper (state, payload) {
    state.shipping = payload
  },
  applyDiscount (state, amount) {
    state.discount = amount
  },
  // save items to local storage
  saveCart (state) {
    if (localStorage !== null && JSON !== null) {
      localStorage[state.cartName + '_items'] = JSON.stringify(state.items)
    }
  },
  // adds an item to the cart
  addToCart (state, { product, variant, quantity }) {
    quantity *= 1
    quantity = isNaN(quantity) ? 0 : quantity
    if (quantity !== 0 && variant && variant.price) {
      // update quantity for existing item
      let found = false

      for (let i = 0; i < state.items.length && !found; i++) {
        let item = state.items[i]
        if (item._id === product._id && item.vid === variant._id) {
          found = true
          let quantity1 = item.quantity
          quantity1 *= 1
          quantity1 = isNaN(quantity1) ? 0 : quantity1
          item.quantity = quantity1 + quantity
          if (item.weight == null) { item.weight = 0 }
          item.slug = product.slug
          if (item.quantity <= 0) {
            state.items.splice(i, 1)
            state.skuArray.splice(i, 1)
            state.variantsArray.splice(i, 1)
          }
        }
      }

      // new item, add now
      if (!found && variant && variant.price) {
        let item = { vendor_id: product.vendor_id, vendor_name: product.vendor_name, vendor_email: product.vendor_email, _id: product._id, name: product.name, slug: product.slug, mrp: variant.mrp, price: variant.price, quantity: quantity, image: variant.image, category: product.category, size: variant.size, weight: variant.weight, vid: variant._id }
        state.items.push(item)
        state.skuArray.push(item._id)
        state.variantsArray.push(item.vid)
      }

      // save changes
      if (localStorage !== null && JSON !== null) {
        localStorage[state.cartName + '_items'] = JSON.stringify(state.items)
      }
    }
  },

  clearCart () {
    state.items = []
    state.skuArray = []
    state.variantsArray = []
    if (localStorage !== null && JSON !== null) {
      localStorage[state.cartName + '_items'] = JSON.stringify(state.items)
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
